import React, { useEffect, useRef, useState } from "react";
import axios from "../../../helpers/axios";
import { IMAGE_BASE_URL } from "../../../helpers/constants";
import { Input as CkInput, Menu, MenuItem } from "@chakra-ui/react";

import { useDispatch, useSelector } from "react-redux";
import AgentVisibilityPopup from "./AgentVisibilityPopup";
import InterestRateInput from "./InterestRateInput";
import { dataURItoBlob, isNonZero } from "../../../helpers/utils";
import LoanDataService from "../../../services/loanproducts";
import {
  AlertDialog,
  CustomSelect,
  SecondaryTabGroup,
  CropPopup,
  ImageInput,
  OffCanvasModal,
} from "../../../components";
import DefaultImage from "../../../images/image.svg";
import moment from "moment";
import { useMediaQuery } from "react-responsive";
import { Button, Tooltip } from "@mui/material";
import { IoMdArrowDropdown } from "react-icons/io";
import LoaderComp from "../../../components/LoaderComp";
import MoonLoader from "react-spinners/MoonLoader";
import { useToast } from "@chakra-ui/react";
import { Controller, FormProvider, useForm } from "react-hook-form";
import dayjs from "dayjs";
import AddDeclarationModal from "./AddDeclarationModal";
import loanproducts from "../../../services/loanproducts";

const CreateModal = ({
  closePopUp,
  id,
  edit = false,
  activeFilters,
  pagePermission,

  ...props
}) => {
  const isSmallScreen = useMediaQuery({ maxWidth: 648 });
  const toast = useToast();

  const [uploading, setUploading] = useState(false);
  const [image, setImage] = useState(null);
  const [mounted, setMounted] = useState(false);
  const [isFormEdit, setIsFormEdit] = useState(false);
  const [productID, setProductID] = useState(id);

  const [editFilterConsent, setEditFilterConsent] = useState(false);
  const [displayAgentsCount, setDisplayAgentsCount] = useState(
    isSmallScreen ? 3 : 5
  );
  const [showCrop, setShowCrop] = useState(false);
  const [isInHouse, setIsInHouse] = useState(false);
  const [croppedImage, setCroppedImage] = useState(false);
  const settings = useSelector((state) => state.settings);
  const [agentSelectionModalVisible, setAgentSelectionModalVisible] =
    useState(false);
  const [loanProviders, setLoanProviders] = useState([]);
  const [selectedLoanProvider, setSelectedLoanProvider] = useState(null);

  //console.log("loan provider ======", loanProviders)

  const [checkedAgents, setCheckedAgents] = useState([]);
  const [loading, setLoading] = useState(false);
  const [settingsIndex, setSettingsIndex] = useState(
    props?.settingsIndex || {
      veh: 0,
      cat: 0,
      typ: 0,
      schm: 0,
    }
  );
  const [tooltipOpen, setTooltipOpen] = useState(false);
  const [showDeclarationModal, setShowDeclarationModal] = useState(false);
  const [declarationFormData, setDeclarationFormData] = useState([]);


  const intialFormData = useRef({
    name: "",
    loanProvider: "",
    icon: "",
    productType: settings.loanProviderTypes[0].id,
    category: activeFilters?.category || settings.categories[0].id,
    vehicle: activeFilters?.vehicle || settings.categories[0].id,  //vehicle
    loanType: activeFilters?.loanType || settings.categories[0].types[0].id,
    scheme:
      activeFilters?.scheme || settings.categories[0].types[0].schemes[0].id,
    usage: activeFilters?.usage || settings.productUsages[0].id,
    motorType: activeFilters?.motorType || settings.productMotorTypes[0].id,
    approvalTime: activeFilters?.approvalTime || settings.approvalTimes[0].id,
    ltv: activeFilters?.ltv || settings.ltvs[0].id,
    agentVisibilityRule: "",
    remarks1: "",
    remarks2: "",
    remarks: [],
    agents: [],
    agentruleinfo: null,
    isPublic: 0,
    interests: [],
    inhouseProduct: 0,
    collect_first_installment: "0",
  }).current;

  const methods = useForm({
    defaultValues: intialFormData,
  });
  const {
    register,
    control,
    setValue,
    getValues,
    clearErrors,
    watch,
    trigger,
    reset,
    formState: { errors, isSubmitted, isValid },
  } = methods;

  const formValues = watch();
  const modalRef = useRef(null);

  const [createData, setCreateData] = useState(intialFormData);

  const [initialProductData, setInitialProductData] = useState(null);
  const alertConfig = useRef({
    productExists: {
      key: "productExists",
      title: "Product already exists",
      description:
        "Under the selected loan provider or agent, the same product is available for this filter's criteria. Do you want to overwrite?",
      primary: {
        onPress: onProceedProductFetch,
        buttonTxt: "Yes",
      },
      secondary: {
        onPress: onCancelProductFetch,
        buttonTxt: "No",
      },
    },
  }).current;

  const [alert, setAlert] = useState(null);

  useEffect(() => {
    setMounted(true);
    const handleResize = () => {
      if (window.innerWidth < 500) {
        setDisplayAgentsCount(3);
      } else {
        setDisplayAgentsCount(5);
      }
    };

    // Add event listener for resize event
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    if (tooltipOpen) {
      setTimeout(() => {
        setTooltipOpen(false);
      }, 1500);
    }
  }, [tooltipOpen]);

  useEffect(() => {
    if (croppedImage) {
      setValue("icon", "-");
    }
  }, [croppedImage]);

  useEffect(() => {
    if (productID) {
      onUpdateProductForm(productID);
    }
  }, [productID]);

  useEffect(() => {
    if (createData.productType === "eea49ff4-655f-412e-8bb2-22e0cf8578db") {
      setIsInHouse(true);
    } else {
      setIsInHouse(false);
    }
    refreshLoanProviders(createData);
  }, [createData.productType]);

  async function refreshLoanProviders(data) {
    const providers = await getProviders(data.productType);

    if (data.productType === "eea49ff4-655f-412e-8bb2-22e0cf8578db") {
      setIsInHouse(true);
    } else {
      setIsInHouse(false);
    }
    setLoanProviders(providers);
  }
  async function onUpdateProductForm(id) {
    setLoading(true);
    let res = await axios.get(
      `/admin/loan/product/info/${id}`
    );
    console.log("data====", res.data.data.loanProvider);
    setSelectedLoanProvider(res.data.data.loanProvider);

    await refreshLoanProviders(res.data.data);

    setTimeout(() => {
      let data = { ...res.data.data };
      data.isInHouse = data.inhouseProduct ? true : false;
      if (data.inhouseProduct) {
        data.loanProvider = data.inhouseAgent;
      }
      data = {
        ...data,
        interests: data?.interests?.map((interest, index) => {
          interest.editable = false;
          return interest;
        }),
      };
      const parsedFormData = typeof data?.form_data === "string"
        ? JSON.parse(data.form_data)
        : data?.form_data;
      setDeclarationFormData(parsedFormData);
      setCreateData(data);
      setValue("loanProvider", data?.loanProvider);
      setValue("icon", data?.icon);
      setValue("name", data?.name);
      setValue("agents", data?.agents);
      // actual product data used for form reset feature
      setInitialProductData(data);
      setIsFormEdit(true);
      refreshAgentSelectionList(data);
      setLoading(false);
    }, 500);
  }

  const refreshAgentSelectionList = async (data) => {
    // update agent API
    try {
      const res = await LoanDataService.getAgents({
        data: { keyword: "" },
      });
      //console.log("agent data::", res);
      if (!Array.isArray(res)) return;

      let agents = [];
      let selectedAgents = [];
      if (data?.agentruleinfo?.allAgents == 1) {
        //console.log("all");
        agents = res;
        selectedAgents = res;
      } else if (data?.agentruleinfo?.excludeAgents == 1) {
        const agentIDs = data.agents?.map((a, i) => a.id);
        selectedAgents = res?.filter((a, i) => {
          if (!agentIDs.includes(a.id)) return true;
        });
        agents = data.agents;

        //console.log("except");
      } else {
        //console.log("only");
        agents = data?.agents;
        selectedAgents = data?.agents;
      }
      //console.log({ selectedAgents });
      setValue("agents", agents);
      setCreateData((_) => ({ ..._, agents: agents }));
      setCheckedAgents(selectedAgents);
    } catch (e) {
      console.error(e);
      // report
    }
  };

  async function onModifyFilter(idx, label, data) {
    //console.log("====", createData.vehicle)
    const product = await checkLoanProviderProductExists({
      loanProvider: createData.loanProvider,
      productType: createData.productType,
      vehicle: createData.vehicle,  //vehicle
      category: createData.category,
      loanType: createData.loanType,
      scheme: createData.scheme,
      usage: createData.usage,
      motorType: createData.motorType,
      approvalTime: createData.approvalTime,
      ltv: createData.ltv,
      loanProvider:
        typeof createData.loanProvider?.id == "string"
          ? createData.loanProvider.id
          : createData.loanProvider,
      ...data,
    });


    if (product) {
      setAlert({
        ...alertConfig.productExists,
        data: { productID: product.id },
      });
      return;
    } else {
      if (label == "category") {
        let category = settings.categories.find((i) => i.id === data.category);
        setSettingsIndex({ ...settingsIndex, cat: idx, typ: 0 });
        setCreateData((_) => ({
          ..._,
          ...data,
          loanType: settings.categories[idx].types[0].id,
          scheme: settings.categories[idx].types[0].schemes[0].id,
        }));
      } else if (label == "loanType") {
        setSettingsIndex({ ...settingsIndex, typ: idx, schm: 0 });
        setCreateData((_) => ({
          ..._,
          ...data,
          scheme:
            settings.categories[settingsIndex.cat].types[idx].schemes[0].id,
        }));
      } else if (label == "scheme") {
        setSettingsIndex({ ...settingsIndex, schm: idx });
        setCreateData((_) => ({
          ..._,
          ...data,
          loanType:
            settings.categories[settingsIndex.cat].types[settingsIndex.typ].id,
        }));
      }
      else if (label == "vehicle") {              //vehicle
        setSettingsIndex({ ...settingsIndex, veh: idx, typ: 0 });
        setCreateData((_) => ({
          ..._,
          ...data,
          vehicle: settings.vehicles[idx].id,
        }));

      } else {
        setCreateData((_) => ({ ..._, ...data }));
      }
    }
    //console.log("resVehicle", settings.vehicles[idx].id)
  }


  async function onLoanProviderChange(provider) {
    //console.log(provider);
    // setCreateData((data) => ({ ...data, loanProvider: value }));
    if (!provider?.id) return;
    /// it is ID string
    const loanProvider = provider?.id;
    createData.ltv = provider?.ltv;
    createData.approvalTime = provider?.approvalTime;
    createData.featured = provider?.featured;
    const product = await checkLoanProviderProductExists({
      loanProvider,
      productType: createData.productType,
      vehicle: createData.vehicle,       //vehicle
      category: createData.category,
      loanType: createData.loanType,
      scheme: createData.scheme,
      usage: createData.usage,
      motorType: createData.motorType,
      approvalTime: provider.approvalTime,
      ltv: provider.ltv,
      featured: provider.featured,
      inhouseProduct: isInHouse ? 1 : 0,
    });
    //console.log("existing product:: ", product, loanProvider);
    if (product) {
      setAlert({
        ...alertConfig.productExists,
        data: { productID: product.id, loanProvider },
      });
      return true;
    } else {
      return false;
    }
  }



  async function onProceedProductFetch(data) {
    clearErrors();
    setProductID(data.productID);
    console.log("productId", data.productID)
    setAlert(null);
    setEditFilterConsent(false);
  }

  async function onCancelProductFetch() {
    setAlert(null);
  }

  const onInitialProductDataChange = (data) => {
    setInitialProductData(data);
  };

  const handleAgentSelectionChange = ({
    agentRule,
    agentList,
    checkedAgents,
  }) => {
    let ruleInfo = settings.agentVisibilityRules.find(
      (obj) => obj.id == agentRule
    );
    hideAgentModal();
    setValue("agents", [...agentList]);
    setValue("agentruleinfo", ruleInfo);
    setCreateData((data) => ({
      ...data,
      agentVisibilityRule: agentRule,
      agents: [...agentList],
      agentruleinfo: ruleInfo,
    }));
    setCheckedAgents(checkedAgents);
  };

  const hideAgentModal = () => {
    setAgentSelectionModalVisible(false);
  };

  const showAgentModal = () => {
    setAgentSelectionModalVisible(true);
  };

  const getAlerts = () => {
    try {
      let interestValues = [];
      let scheduleInterestValues = [];
      let scheduleDateValues = [];
      let hasUnSavedChanges = false;

      if (createData.interests.length === 0) {
        return {
          title: "Oops!",
          description: "At least one interest must be specified",
          primary: {
            onPress: () => setAlert(null),
            buttonTxt: "Ok",
          },
        };
      }

      if (Array.isArray(createData.interests)) {
        // console.log("createData.interests", createData);
        initialProductData.interests?.map((interest, index) => {
          if (
            interest?.editable &&
            !interest?.startDate &&
            !interest?.endDate &&
            !interest?.remarks1 &&
            !interest?.remarks1 &&
            !interest?.minimum_loan_amount &&
            !interest.admin_fee_status
          )
            return;
          if (
            !hasUnSavedChanges &&
            (interest?.editable || interest?.schedule?.editable)
            // ((interest?.editable && interest?.modified) ||
            //   (interest?.schedule?.editable && interest?.schedule?.modified))
          ) {
            hasUnSavedChanges = index == 0 ? "Low Tier" : "High Tier";
          }

          if (interest?.interest) {
            interestValues.push(interest.interest);
          } else {
            interestValues.push(0);
          }

          //console.log("ALLINTEREST", interest, interest?.schedule?.interest);
          if (interest?.schedule?.interest) {
            scheduleInterestValues.push(interest?.schedule?.interest);
          } else {
            scheduleInterestValues.push(0);
          }
          if (interest?.schedule?.scheduleDate) {
            scheduleDateValues.push(interest?.schedule?.scheduleDate);
          }
        });
      }

      if (hasUnSavedChanges) {
        return {
          title: "Oop!",
          description: `You have unsaved interest tab changes. Please do save and proceed.`,
          primary: {
            onPress: () => setAlert(null),
            buttonTxt: "Ok",
          },
        };
      }

      if (interestValues.length > 1) {
        const HighTierArrray = [
          Number(interestValues[1]).toFixed(2),
          Number(
            scheduleInterestValues[1] !== undefined
              ? scheduleInterestValues[1]
              : ""
          ).toFixed(2),
        ]?.filter((it) => it !== "0.00");
        const LowTierArray = [
          Number(interestValues[0]).toFixed(2),
          Number(
            scheduleInterestValues[0] !== undefined
              ? scheduleInterestValues[0]
              : ""
          ).toFixed(2),
        ]?.filter((it) => it !== "0.00");
        // console.log(
        //   "INCLUDEARRAY",
        //   interestValues,
        //   scheduleInterestValues,
        //   HighTierArrray,
        //   LowTierArray
        // );
        if (
          HighTierArrray?.includes(Number(interestValues[0]).toFixed(2)) ||
          HighTierArrray?.includes(
            Number(
              scheduleInterestValues[0] !== undefined
                ? scheduleInterestValues[0]
                : ""
            ).toFixed(2)
          )
        ) {
          return {
            title: "Oop!",
            description: "Same interest value already exists in other tier",
            primary: {
              onPress: () => setAlert(null),
              buttonTxt: "Ok",
            },
          };
        } else if (
          LowTierArray?.includes(Number(interestValues[1]).toFixed(2)) ||
          LowTierArray?.includes(
            Number(
              scheduleInterestValues[1] !== undefined
                ? scheduleInterestValues[1]
                : ""
            ).toFixed(2)
          )
        ) {
          return {
            title: "Oop!",
            description: "Same interest value already exists in Low tier..!",
            primary: {
              onPress: () => setAlert(null),
              buttonTxt: "Ok",
            },
          };
        }
      }

      if (
        (interestValues.length > 1 &&
          isNonZero(interestValues[0]) &&
          isNonZero(interestValues[1]) &&
          Number(interestValues[0]).toFixed(2) ==
          Number(interestValues[1]).toFixed(2)) ||
        (scheduleInterestValues.length > 1 &&
          isNonZero(scheduleInterestValues[0]) &&
          isNonZero(scheduleInterestValues[1]) &&
          Number(scheduleInterestValues[0]).toFixed(2) ==
          Number(scheduleInterestValues[1]).toFixed(2))
      ) {
        return {
          title: "Oop!",
          description: "Same interest value already exists",
          primary: {
            onPress: () => setAlert(null),
            buttonTxt: "Ok",
          },
        };
      }

      if (scheduleDateValues.length > 1) {
        const schedDate1 = moment(scheduleDateValues[0], "YYYY-MM-DD HH:mm");
        const schedDate2 = moment(scheduleDateValues[1], "YYYY-MM-DD HH:mm");
        const datetime1 = moment(scheduleDateValues[0], "YYYY-MM-DD HH:mm");
        const datetime2 = moment(scheduleDateValues[1], "YYYY-MM-DD HH:mm");

        if (datetime1.isBefore(datetime2)) {
          //console.log("datetime1 is before datetime2");
        } else if (datetime1.isSame(datetime2)) {
          //console.log("datetime1 is the same as datetime2");
        } else if (datetime1.isAfter(datetime2)) {
          //console.log("datetime1 is after datetime2");
        }
        if (schedDate1.isSame(schedDate2)) {
          return {
            title: "Oop!",
            description: "Same schedule date already exists",
            primary: {
              onPress: () => setAlert(null),
              buttonTxt: "Ok",
            },
          };
        }
      }

      return false;
    } catch (error) {
      console.error(error);
    }
  };

  function validate(includeAlerts) {
    let _alert = null;
    let _hasErrors = false;
    if (includeAlerts) {
      _alert = getAlerts();
      _hasErrors = !!_alert;
      //console.log({ _alert });
      setAlert(_alert);
    }

    //console.log({ _hasErrors });

    return !_hasErrors;
  }
  const handleFormSave = (formData) => {
    setDeclarationFormData(formData);
  }

  const onSubmit = async (formData) => {
    try {
      const valid = validate(true);
      if (!valid) {
        return false;
      }
      const payload = {
        ...createData,
        name: formValues.name,
        icon: formValues.icon,
        agents: formValues.agents,
        loanProvider: formValues.loanProvider,
        inhouseProduct: isInHouse ? 1 : 0,
        inhouseAgent: isInHouse ? formValues.loanProvider : null,
      };


      if (croppedImage) {
        let blobFile = await dataURItoBlob(croppedImage);
        let formData = new FormData();
        formData.append("file", blobFile, "crop-icon.jpg");
        formData.append("module", "loanproduct");
        let fileRes = await axios.post("/admin/upload/image", formData);
        payload.icon = fileRes.data.data;
      }

      const agents = payload.agents.map((a, i) => a.id);
      payload["agents"] = agents;


      if (Array.isArray(payload.interests)) {
        // console.log("payload.interests==", payload.interests)
        for (let index = 0; index < payload.interests.length; index++) {
          const interests = payload.interests.map((interest, index) => {

            // payload.interests = payload.interests.map((interest) => {
            //   // ✅ Preserve ID if missing
            //   if (!interest.id && interest.idFromBackend) {
            //     interest.id = interest.idFromBackend;
            //   }

            if (interest?.schedule?.scheduleDate) {
              interest["startDate"] = dayjs(interest.startDate).format(
                "YYYY/MM/DD"
              );
              interest["endDate"] = dayjs(interest.endDate).format(
                "YYYY/MM/DD"
              );
              interest["schedule"]["startDate"] = dayjs(
                interest["schedule"]["startDate"]
              ).format("YYYY/MM/DD");
              interest["schedule"]["endDate"] =
                interest["schedule"]["endDate"] !== null &&
                  interest["schedule"]["endDate"] !== ""
                  ? dayjs(interest["schedule"]["endDate"]).format("YYYY/MM/DD")
                  : null;
              interest["schedule"]["scheduleDate"] = moment(
                interest["schedule"]["scheduleDate"]
              ).format("yyyy/MM/DD HH:mm:ss");
            }
            return interest;
          });
          payload["interests"] = interests;
        }
      }

      //   if (Array.isArray(payload.interests)) {
      //   payload.interests = payload.interests.map((interest) => {
      //     // ✅ Preserve ID if missing
      //     if (!interest.id && interest.idFromBackend) {
      //       interest.id = interest.idFromBackend;
      //     }

      //     // ✅ Format dates if schedule exists
      //     if (interest?.schedule?.scheduleDate) {
      //       interest.startDate = dayjs(interest.startDate).format("YYYY/MM/DD");
      //       interest.endDate = dayjs(interest.endDate).format("YYYY/MM/DD");

      //       interest.schedule.startDate = dayjs(interest.schedule.startDate).format("YYYY/MM/DD");
      //       interest.schedule.endDate =
      //         interest.schedule.endDate
      //           ? dayjs(interest.schedule.endDate).format("YYYY/MM/DD")
      //           : null;

      //       interest.schedule.scheduleDate = moment(interest.schedule.scheduleDate)
      //         .format("yyyy/MM/DD HH:mm:ss");
      //     }

      //     return interest;
      //   });
      // }

      payload.form_data = declarationFormData;

      if (isFormEdit) {
        await onProductUpdate(productID, payload);
      } else {
        const { data } = await axios.post(
          `/admin/loan/product/create`,
          payload
        );
        toast({
          description: "Loan product created successfully",
          status: "success",
          duration: 3000,
          isClosable: true,
        });
        if (data?.data?.id) {
          setProductID("");
          setTimeout(() => {
            setProductID(data?.data?.id);
            console.log("productId", productID)
            setLoading(false);
          }, 1000);
        }
      }
    } catch (error) {
      console.error(error);
    } finally {
    }
  };
  //console.log("Update Product====", productID);

  async function onProductUpdate(productID, payload) {
    //console.log("Update Product====", productID, payload);
    const { data } = await axios.put(
      `/admin/loan/product/update/${productID}`,
      payload
    );
    toast({
      description: "Loan product updated successfully",
      status: "success",
      duration: 3000,
      isClosable: true,
    });
    if (data?.data?.id) {
      setProductID("");
      setTimeout(() => {
        setProductID(data?.data?.id);
        console.log("productId", productID)
        setLoading(false);
      }, 1000);
    } else {
    }
  }

  async function getProviders(productType) {
    try {
      let response = null;
      if (productType === "eea49ff4-655f-412e-8bb2-22e0cf8578db") {
        response = await axios.post(
          `/admin/agent/list/all`,
          {
            sortKey: "name",
            sortOrder: "asc",
          }
        );
        //console.log("agents data:", response.data.data);
      } else {
        response = await axios.post(
          `/admin/loan/provider/list/all`,
          { providerType: productType }
        );
        //console.log("providers data:", response.data.data);
      }
      return response?.data?.data;
    } catch (error) {
      console.error("Error fetching data:", error);
      // Handle error if needed
    }
  }

  const checkLoanProviderProductExists = async (payload) => {
    try {
      //console.log({ payload });
      const { data } = await axios.post(
        `/admin/loan/product/check`,
        payload
      );
      return data?.data;
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <>
      {alert ? <AlertDialog visible={!!alert} {...alert} /> : null}
      <OffCanvasModal
        ref={modalRef}
        title={isFormEdit ? "Update Loan Product" : "Create Loan Product"}
        active={true}
        // active={active}
        error={
          isSubmitted && Object.keys(errors).length
            ? "Please fill required fields"
            : ""
        }
        setActive={closePopUp}
      >
        {loading ? (
          <div className="flex h-screen w-screen items-center justify-center">
            <MoonLoader
              color={"grey"}
              loading={true}
              size={50}
              aria-label="Loading Spinner"
              data-testid="loader"
            />
          </div>
        ) : (
          <FormProvider {...methods}>
            <form onSubmit={methods.handleSubmit(onSubmit)}>
              <div className="w-full grid grid-cols-1 sm:grid-cols-2 gap-x-3 gap-y-4">
                <div className="col-span-1 w-full">
                  <label className="block mb-[6px] text-[13px] text-[#495159]">
                    Type
                  </label>
                  <SecondaryTabGroup
                    disabled={isFormEdit}
                    active={createData.productType}
                    onClick={(value) => {
                      setIsFormEdit(false);
                      reset();
                      setCreateData((data) => ({
                        ...data,
                        productType: value,
                        loanProvider: "",
                        icon: "",
                        name: "",
                      }));
                      setLoanProviders([]);
                    }}
                    tabs={settings.loanProviderTypes}
                    customLabel={"name"}
                    customValue={"id"}
                  />
                </div>


                <div className="col-span-1">
                  <label className="block mb-[6px] text-[13px] text-[#495159]">
                    {isInHouse ? `Agent` : `Loan Provider`}
                  </label>
                  <Controller
                    control={control}
                    name="loanProvider"
                    rules={{
                      required: true,
                    }}
                    render={({ field }) => {
                      return (
                        <CustomImageSelect
                          error={errors?.loanProvider}
                          name={field.name}
                          ref={field.ref}
                          placeholder={
                            isInHouse ? "Select Agent" : "Select Loan Provider"
                          }
                          onSelect={async (lp) => {
                            const hasProduct = await onLoanProviderChange(lp);
                            if (!hasProduct) {
                              field.onChange(lp?.id);
                              const lProvider = loanProviders.find(
                                (l, i) => l.id == lp?.id
                              );
                              clearErrors(["icon", "name", "loanProvider"]);
                              setValue("icon", lProvider.icon);
                              setValue("name", lProvider.name);
                              setIsFormEdit(false);
                            }
                          }}
                          value={field.value}
                          disabled={isFormEdit}
                          options={loanProviders}
                        />
                      );
                    }}
                  />
                </div>
                <div className="col-span-1">
                  <label className="block mb-[6px] text-[13px] text-[#495159]">
                    Product Image
                  </label>
                  <Controller
                    control={control}
                    name="icon"
                    rules={{
                      required: true,
                    }}
                    render={({ field }) => {
                      return (
                        <ImageInput
                          error={errors?.icon}
                          image={
                            croppedImage
                              ? croppedImage
                              : field.value && field.value !== ""
                                ? `${IMAGE_BASE_URL}/${field.value}`
                                : ""
                          }
                          setImage={(event) => {
                            if (event.target.files && event.target.files[0]) {
                              setShowCrop(true);
                              setImage(
                                URL.createObjectURL(event.target.files[0])
                              );
                            }
                          }}
                        />
                      );
                    }}
                  />
                </div>
                <div className="col-span-1">
                  <label className="block mb-[6px] text-[13px] text-[#495159]">
                    Product Name
                  </label>
                  <Controller
                    control={control}
                    name={`name`}
                    rules={{
                      required: true,
                    }}
                    render={({ field }) => {
                      return (
                        <CkInput
                          value={field.value}
                          type="text"
                          placeholder={"Product Name"}
                          fontSize={"13px"}
                          borderRadius={"4px"}
                          // isInvalid={errors?.name}
                          onChange={(e) => {
                            field.onChange(e.target.value);
                          }}
                          sx={{
                            boxShadow: errors?.name
                              ? "0 0 0 1px #ff4d4f"
                              : "none",
                            border: errors?.name ? "none" : "1px",
                            borderColor: errors?.name ? "#ff4d4f" : "#E2E8F0",
                          }}
                        />
                      );
                    }}
                  />
                </div>
                <div className="col-span-1">
                  <label className="block mb-[6px] text-[13px] text-[#495159]">
                    Vehicle
                  </label>
                  <SecondaryTabGroup
                    disabled={isFormEdit}
                    customLabel={"name"}
                    active={createData.vehicle}
                    onClick={(value, idx) =>
                      onModifyFilter(idx, "vehicle", { vehicle: value })
                    }
                    tabs={settings.vehicles}
                    customValue={"id"}
                  />
                </div>
                <div className="col-span-1">
                  <label className="block mb-[6px] text-[13px] text-[#495159]">
                    Type
                  </label>
                  <SecondaryTabGroup
                    disabled={isFormEdit}
                    customLabel={"name"}
                    active={createData.category}
                    onClick={(value, idx) =>
                      onModifyFilter(idx, "category", { category: value })
                    }
                    tabs={settings.categories}
                    customValue={"id"}
                  />
                </div>
                <div className="col-span-1">
                  <label className="block mb-[6px] text-[13px] text-[#495159]">
                    Category
                  </label>
                  <SecondaryTabGroup
                    disabled={isFormEdit}
                    customLabel={"name"}
                    active={createData.loanType}
                    onClick={(value, idx) =>
                      onModifyFilter(idx, "loanType", { loanType: value })
                    }
                    tabs={settings.categories[settingsIndex.cat].types}
                    customValue={"id"}
                  />
                </div>
                <div className="col-span-1">
                  <label className="block mb-[6px] text-[13px] text-[#495159]">
                    Motor
                  </label>
                  <SecondaryTabGroup
                    disabled={isFormEdit}
                    customLabel={"name"}
                    active={createData.motorType}
                    onClick={(value, idx) =>
                      onModifyFilter(idx, "motorType", { motorType: value })
                    }
                    tabs={settings.productMotorTypes}
                    customValue={"id"}
                  />
                </div>
                <div className="col-span-1">
                  <label className="block mb-[6px] text-[13px] text-[#495159]">
                    Usage
                  </label>
                  <SecondaryTabGroup
                    disabled={isFormEdit}
                    customLabel={"name"}
                    active={createData.usage}
                    onClick={(value, idx) =>
                      onModifyFilter(idx, "usage", { usage: value })
                    }
                    tabs={settings.productUsages}
                    customValue={"id"}
                  />
                </div>
                <div className="col-span-1">
                  <label className="block mb-[6px] text-[13px] text-[#495159]">
                    Scheme
                  </label>
                  <SecondaryTabGroup
                    disabled={isFormEdit}
                    customLabel={"name"}
                    active={createData.scheme}
                    onClick={(value, idx) =>
                      onModifyFilter(idx, "scheme", { scheme: value })
                    }
                    tabs={
                      settings.categories[settingsIndex.cat].types[
                        settingsIndex.typ
                      ].schemes.map((scheme) => ({
                        ...scheme,
                        disabled:
                          settings.vehicles[settingsIndex.veh]?.name === 'Commercial' &&
                          scheme.name === 'Balloon',
                      }))
                    }
                    customValue={"id"}
                  />
                </div>
                <div className="col-span-1">
                  <label className="block mb-[6px] text-[13px] text-[#495159]">
                    Collect First Installment?
                  </label>
                  <SecondaryTabGroup
                    disabled={isFormEdit}
                    customLabel={"name"}
                    active={createData.collect_first_installment}
                    onClick={(value, idx) =>
                      onModifyFilter(idx, "collect_first_installment", {
                        collect_first_installment: value,
                      })
                    }
                    tabs={settings.collect_first_installment_options?.map(
                      (it) => {
                        return {
                          ...it,
                          id: it.value,
                        };
                      }
                    )}
                    customValue={"id"}
                  />
                </div>
                <div>
                  <label className="block mb-[6px] text-[13px] text-[#495159]">
                    Listing Type
                  </label>
                  <SecondaryTabGroup
                    customLabel={"name"}
                    active={createData.featured ? 1 : ""}
                    onClick={(value) =>
                      setCreateData((data) => ({
                        ...data,
                        featured: !data.featured,
                      }))
                    }
                    tabs={[{ name: "Featured", id: 1 }]}
                    customValue={"id"}
                  />
                </div>
              </div>

              {isInHouse ? (
                <div className="mb-10 mt-10"></div>
              ) : (
                <div className="mb-10 mt-10">
                  <label className="block mb-[6px] text-[13px] text-[#495159]">
                    Agent Visibility{" "}
                    {createData.agentruleinfo ? (
                      <span className="font-bold">
                        {" "}
                        - {createData?.agentruleinfo?.name}
                      </span>
                    ) : (
                      ""
                    )}
                  </label>

                  <Controller
                    name="agents"
                    control={control}
                    rules={{ required: "Please select the agents" }}
                    render={({ field }) => (
                      <div onClick={showAgentModal}>
                        {createData.agents?.length > 0 ? (
                          <div
                            className={`flex w-[100%] overflow-hidden border cursor-pointer border-gray-300 ${createData.agents?.length > 0 ? "border-0" : ""
                              } rounded-md h-[48px] items-center px-3 py-2`}
                          >
                            <div className="flex flex-row items-center text-[13px]">
                              {createData.agents
                                .slice(0, displayAgentsCount)
                                .map((item, index) => {
                                  return <AgentItem key={index} data={item} />;
                                })}
                              {createData.agents.length - displayAgentsCount >
                                0 ? (
                                <p>
                                  {createData.agents.length -
                                    displayAgentsCount}
                                  +
                                </p>
                              ) : null}
                            </div>
                          </div>
                        ) : (
                          <p
                            className={`rounded border text-[13px] ${errors?.agents
                              ? "error-shadow"
                              : "border-1 border-[#E2E8F0]"
                              } px-4 py-3`}
                          >
                            Select the agents
                          </p>
                        )}
                      </div>
                    )}
                  />
                </div>
              )}
              <div>
                <Button style={{ float: "right" }}
                  type="button"
                  className="sav_btn"
                  onClick={() => {
                    console.log("Clicked Add Declaration");
                    setShowDeclarationModal(true);
                  }}
                >
                  Declaration Form
                </Button>
                <AddDeclarationModal
                  loanProduct={createData}
                  loanProvider={selectedLoanProvider}
                  open={showDeclarationModal}
                  handleSave={handleFormSave}
                  declarationFormData={declarationFormData}
                  onClose={() => setShowDeclarationModal(false)}
                />
                <InterestRateInput
                  formSubmitted={isSubmitted}
                  onInitialProductDataChange={onInitialProductDataChange}
                  initialData={initialProductData}
                  isExistingProduct={isFormEdit}
                  data={createData}
                  setData={(data) => {
                    setCreateData(data);
                    validate();
                  }}
                  setInitialProductData={(data) => {
                    setInitialProductData(data);
                    // validate();
                  }}
                />
              </div>

              <div className="flex mt-10">
                <Tooltip
                  arrow
                  open={tooltipOpen}
                  title={"Please fill required fields"}
                >
                  <Button
                    onClick={(e) => {
                      if (Object.keys(errors).length) setTooltipOpen(true);
                    }}
                    type="submit"
                    disabled={uploading}
                    className="sav_btn"
                  >
                    {isFormEdit ? `Update Loan Product` : `Create Loan Product`}
                  </Button>
                </Tooltip>
                <Button
                  type="button"
                  onClick={() => {
                    closePopUp(false);
                  }}
                  className="can_btn"
                >
                  Cancel
                </Button>
              </div>
            </form>
          </FormProvider>
        )}
      </OffCanvasModal>
      {agentSelectionModalVisible ? (
        <AgentVisibilityPopup
          intialAgentValues={checkedAgents?.map((a) => a.id)}
          initialRule={createData.agentVisibilityRule}
          onFinish={handleAgentSelectionChange}
          onHide={hideAgentModal}
        />
      ) : null}
      {showCrop ? (
        <CropPopup
          image={image}
          setActive={setShowCrop}
          setImage={setCroppedImage}
        />
      ) : null}
    </>
  );
};

function AgentItem({ data }) {
  return (
    <div className="flex px-1 pr-3 py-1 items-center bg-[#dae7ff] rounded-2xl mr-2 border-blue-800 border-1">
      <div>
        <img
          className="w-6 h-6 rounded-xl mr-2 overflow-hidden"
          src={data.icon ? `${IMAGE_BASE_URL}/${data.icon}` : DefaultImage}
        />
      </div>
      <div className="overflow-hidden overflow-ellipsis">
        <p className="text-[12px] font-medium text-black capitalize max-w-[100px]">
          {data.name}
        </p>
      </div>
    </div>
  );
}

export const CustomImageSelect = ({
  disabled,
  onSelect,
  options,
  value,
  placeholder,
  error,
}) => {
  const [selectedOption, setSelectedOption] = useState(null);

  useEffect(() => {
    Array.isArray(options) &&
      setSelectedOption(options?.find((o, i) => o.id == value));
  }, [value, options]);

  //console.log(value, options);
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);
  const containerRef = useRef(null);

  const handleOptionClick = (option) => {
    // setSelectedOption(option);
    setIsOpen(false);
    onSelect(option);
  };

  const handlePlaceholderClick = () => {
    if (disabled) return;
    //console.log({ isOpen });
    setIsOpen(!isOpen);
  };

  const handleClickOutside = (event) => {
    if (
      containerRef.current &&
      !containerRef.current.contains(event.target) &&
      event.target.className !== "select-section"
    ) {
      setIsOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className="relative w-full h-[2.5rem]" ref={containerRef}>
      <div
        onClick={handlePlaceholderClick}
        className={`select-section flex items-center bg-white border border-1  text-gray-700 py-2 px-4 rounded-md leading-tight w-full 
        ${disabled ? "opacity-50" : "opacity-100"}
        ${error ? "error-shadow" : "border-[#E2E8F0]"}
        `}
      >
        <div className="flex h-[24px] items-center w-full">
          {selectedOption ? (
            <>
              <img
                src={`${IMAGE_BASE_URL}/${selectedOption.icon}`}
                alt=""
                className="h-[24px] w-[24px] rounded mr-2"
              />
              <p className="text">{selectedOption.name}</p>
            </>
          ) : (
            <span className="mr-2 text-[13px] text-gray-500">
              {placeholder}
            </span>
          )}
        </div>
        <IoMdArrowDropdown
          className={`ml-2 ${isOpen ? "transform rotate-180" : ""}`}
        />
      </div>
      {isOpen && (
        <div
          ref={dropdownRef}
          className="z-10 absolute mt-1 bg-white border border-gray-300 rounded shadow-lg w-full"
        >
          {options.map((option) => (
            <div
              key={option.id}
              className="flex w-full items-center px-4 py-2 cursor-pointer hover:bg-gray-100"
              onClick={() => handleOptionClick(option)}
            >
              <img
                src={`${IMAGE_BASE_URL}/${option.icon}`}
                alt=""
                className="h-[26px] w-[26px] rounded mr-2"
              />
              <p className="text">{option.name}</p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default CreateModal;
